module.exports = __webpack_public_path__ + "static/media/brunchMenu.fda61540.jpg";